import { render, staticRenderFns } from "./OrderMessage.vue?vue&type=template&id=70e553ad&scoped=true&"
import script from "./OrderMessage.vue?vue&type=script&lang=js&"
export * from "./OrderMessage.vue?vue&type=script&lang=js&"
import style0 from "./OrderMessage.vue?vue&type=style&index=0&id=70e553ad&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e553ad",
  null
  
)

export default component.exports